import { useContext } from 'react';

import PageContext from '../../PageContext';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function usePageContext() {
    return useContext(PageContext);
}
